import * as React from 'react';
import { IHeaderCell, ISortChangeEvent } from './RemoteTable.types';
import HeaderCell from './HeaderCell';

interface IHeaderProps {
  cells: IHeaderCell[];
  onSortChange(e: ISortChangeEvent): any;
}

const Header: React.FC<IHeaderProps> = (props: IHeaderProps) => {
  const { cells, onSortChange } = props;
  const [elements, setElements] = React.useState<IHeaderCell[]>(cells);

  const setActiveHeader = (key: string, sortDirection: 'asc' | 'desc') => {
    setElements(
      cells.map(cell => {
        return {
          ...cell,
          sortDirection: cell.columnKey === key ? sortDirection : null
        };
      })
    );
  };

  return (
    <tr key="header-row">
      {elements.map(cell => {
        return !cell.hide ? (
          <HeaderCell
            key={cell.columnKey}
            headerStyle={cell.headerStyle}
            columnKey={cell.columnKey}
            disableSort={cell.disableSort}
            sortDirection={cell.sortDirection}
            value={cell.value}
            onSortChange={e => {
              setActiveHeader(e.key, e.sortDirection);
              if (onSortChange) {
                onSortChange(e);
              }
            }}
          />
        ) : null;
      })}
    </tr>
  );
};

export default Header;
